import { vendey, execute, csvRows, pipe } from './api.js';
export async function listSales({ date, name, document, warehouseId }) {
  const values = [date, name, document, warehouseId].map(value => String(value || ''));
  if (values.some(value => /[|¬{}]/.test(value))) throw new Error('Los filtros contienen caracteres no admitidos.');
  const result = await execute('spvnt_pedidoscsvweb4', `{|fecha|:|${values[0]}|,|cliente|:|${values[1]}|,|nrocliente|:|${values[2]}|,|ncodalmacen|:|${values[3]}|}`);
  return csvRows(result).map(row => {
    const entries = Object.entries(row);
    const find = (names, index) => entries.find(([key]) => names.includes(key.toUpperCase().replace(/[^A-Z0-9]/g, '')))?.[1] ?? entries[index]?.[1] ?? '';
    return { id: find(['CODIGO', 'NCODFACTURA'], 0), date: find(['FECHA', 'DFECHAFACTURA'], 1),
      name: find(['NOMBRECLI', 'NOMBRECLIENTE', 'CLIENTE', 'CNOMBRECLIENTE'], 2), address: find(['DIRECCION', 'CDIRECCION', 'DIRECCI'], 3),
      total: Number(find(['NTOTAL', 'TOTAL'], 4)), number: find(['COMPROBANTE', 'SERIENRO', 'SERIE', 'CNUMFACTURA'], 5) };
  });
}
export async function saleDetails(id) {
  if (!(Number(id) > 0)) throw new Error('Selecciona una venta válida.');
  const rows = csvRows(await vendey('spVNT_FACTURATICKETCSVWEB', pipe([id, id, ''])));
  return rows.map(row => {
    const values = Object.values(row);
    const pick = (names, index) => Object.entries(row).find(([key]) => names.includes(key.toUpperCase()))?.[1] ?? values[index];
    const quantity = Number(pick(['NCANTIDAD'], values.length > 50 ? 66 : 2));
    const total = Number(pick(['NVENTATOTAL'], values.length > 50 ? 41 : 3));
    const productId = pick(['NCODPRODUCTO'], values.length > 50 ? 30 : 0);
    return { id: String(productId || ''), name: String(pick(['CPRODUCTODESC'], values.length > 50 ? 31 : 1) || ''), quantity, price: total / quantity, total };
  });
}
export async function inventoryAccess(password) {
  const result = await execute('spcontraseniinventarioweb', { CONTRASENIA: password });
  if (!result || !['true', '1'].includes(String(result.success).toLowerCase()) || !['true', '1'].includes(String(result.valido).toLowerCase())) throw new Error(result?.mensaje || 'Contraseña de inventario incorrecta.');
}
export async function adjustStock({ productId, warehouseId, quantity, movement }) {
  if (!(Number(productId) > 0) || !(Number(warehouseId) > 0) || !(Number(quantity) > 0) || !['01', '02'].includes(movement)) throw new Error('Completa producto, almacén, cantidad positiva y tipo de movimiento.');
  return execute('spINVACTUALIZARSTOCKCSVWEBv2', { NCODPRODUCTO: Number(productId), NCODALMACEN: Number(warehouseId), NCANTIDAD: Number(quantity), CTIPOMOVIMIENTO: movement });
}
export async function saveProduct(form) {
  if (!form.name.trim() || !form.family.trim() || !(Number(form.price) >= 0)) throw new Error('Nombre, familia y precio válido son obligatorios.');
  const id = await vendey('spINVPRODUCTOSCSVWEBv2', pipe([form.id || 0, form.name, form.price, form.family, form.controlled ? 1 : 0]));
  const code = Number(String(id).split(/[|¬]/)[0]);
  if (!(code > 0)) throw new Error('El servidor no devolvió el código del producto.');
  // Se conserva el ID confirmado aunque falle el segundo paso.
  form.id = code;
  try { await vendey('spINVPRODUCTOSbarrasCSVWEB', pipe([code, form.barcode || '', ''])); }
  catch (error) { throw new Error(`Producto ${code} guardado. No se guardó el código de barras: ${error.message}`); }
  return code;
}
